import React, {Component, Fragment, useState} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Fab from '@material-ui/core/Fab';
import AddIcon from '@material-ui/icons/Add';
import EditIcon from '@material-ui/icons/Edit';
import Close from '@material-ui/icons/Close';
import {Link} from 'react-router-dom';
import Backdrop from '@material-ui/core/Backdrop';
import SpeedDial from '@material-ui/lab/SpeedDial';
import SpeedDialIcon from '@material-ui/lab/SpeedDialIcon';
import SpeedDialAction from '@material-ui/lab/SpeedDialAction'; 
import FolderIcon from '@material-ui/icons/Folder';
import CRUD_folder from './FormSections/Folder/CRUD_popup';

import {MenuBook} from '@material-ui/icons';

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    zIndex:'1000',
    position:'relative'
  },
  extra_button:{
    position: 'fixed',
    bottom:'80px',
    right:'20px',
    ['@media (min-width:600px)']:{
      right:'35px',
      bottom:'25px'
    }
  },
  exampleWrapper: {
    position: 'fixed',
    bottom:(props)=>(props.extra!=undefined)?'150px':'80px',
    right:'20px',
    ['@media (min-width:600px)']:{
      right:'35px',
      bottom:(props)=>(props.extra!=undefined)?'95px':'25px'
    }
  },

}));

export default function Plus_button(props) {
  const classes = useStyles(props);
  const [open, setOpen] = React.useState(false);
  const [create_folder, setCreateFolder]=useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  const handleOpen = () => {
    setOpen(true);
  };

  if(props.options==undefined || props.options.length==0){return(null)}else{
    let options=[];
    for(let opt of props.options){
      options.push(opt);
    }
    if(props.folder_type!=undefined){
      options.push({label:'Folder', icon:<FolderIcon/>, action:()=>{setCreateFolder(true);}});
    }
    console.log(options, 'OPTIONS');
  return (
    <div style={{position:'relative'}}>
    <div className={classes.root}>
      <div className={classes.exampleWrapper}>
        {(options==undefined || options.length==1)
          ?
          <Link onClick={()=>{(options==undefined)?props.action():options[0].action()}}><Fab  color='secondary' aria-label="add" >
            {(props.edit_button)?<EditIcon/>:<AddIcon/>}
          </Fab>
          </Link>
          :<Fragment>
          <Backdrop open={open}/>
          <SpeedDial
          color={(props.color!=undefined)?props.color:'secondary'}
          ariaLabel="SpeedDial example"
          className={classes.speedDial}
          icon={<SpeedDialIcon/>}
          onClose={handleClose}
          onOpen={handleOpen}
          open={open}
          direction='up'
        >
          {options.map(action => (
            <SpeedDialAction
              style={{backgroundColor:'red'}}
              key={action.label}
              icon={action.icon}
              tooltipTitle={action.label}
              onClick={action.action}
            />
          ))}
        </SpeedDial>
      </Fragment>}
      </div>
      {(props.extra!=undefined && props.extra!=true)?<div className={classes.extra_button}><Link onClick={props.extra.click}><Fab  color='secondary' aria-label="add" >{props.extra.icon}</Fab></Link></div>:null}
      {(create_folder !=true) ? null : <CRUD_folder {...props} handleClose={() => { setCreateFolder(false); }} folder_id={props.current_folder_id} folder_type={props.folder_type} />}

    </div>
    </div>
  );
}}
